/* import __COLOCATED_TEMPLATE__ from './suggestion-group-list.hbs'; */
/* RESPONSIBLE TEAM: team-messenger */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type { SuggestionGroup } from './types';

interface Args {
  displayedSuggestions: SuggestionGroup[];
  showAllSuggestions: boolean;
  hasMoreSuggestions: boolean;
  remainingCount: number;
  onRemoveSuggestion: (groupUuid: string) => void;
  onToggleShowAll: () => void;
}

interface Signature {
  Element: HTMLDivElement;
  Args: Args;
}

export default class SuggestionGroupList extends Component<Signature> {
  @tracked isHoveredTextTruncated = false;

  @action handleMouseEnter(event: MouseEvent) {
    let target = event.currentTarget as HTMLElement;
    let textElement = target.querySelector<HTMLElement>('[data-suggestion-text]');
    if (textElement) {
      this.isHoveredTextTruncated = textElement.scrollWidth > textElement.offsetWidth;
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'MessengerSettings::Sales::SuggestionGroupList': typeof SuggestionGroupList;
  }
}
